import cx from "classnames";
import { useFormContext } from "react-hook-form";
// import chevron from "@/assets/icons/chevron.svg";

import { getError } from "@/utils";

import { SelectItemProps } from "./Item";
import { inputClassName } from "../Input";

import ErrorText from "../ErrorText";
import { ChangeEvent, useEffect, useMemo, useReducer } from "react";

// Select
type SelectProps = Omit<JSX.IntrinsicElements["select"], "children"> & {
  name: string;
  children?: React.ReactElement<SelectItemProps>[];
  // icon?: React.ElementType;
  keepPlaceHolderSize?: boolean;
  placeholder?: string;
};

const Select = ({
  name,
  // icon: Icon,
  value = "",
  defaultValue,
  placeholder,
  className,
  children,
  onChange,
  keepPlaceHolderSize,
  ...rest
}: SelectProps) => {
  const [, forceRender] = useReducer((c) => c + 1, 0);
  const {
    register,
    formState: { errors = {} },
    getValues,
    setValue,
  } = useFormContext() || {};
  const error = getError(errors, name);
  const errorID = `error-${name}`;

  const formValue = getValues?.(name) || value || defaultValue;

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>) => {
    forceRender();
    onChange?.(event);
  };

  const labelClassNames =
    "formInput__label  text-tim-primary leading-none pointer-events-none pt-px mb-2 transition duration-200 hover:text-tim-primary origin-top-left bg-white px-2 text-sm";

  const isEmpty =
    formValue === "" || formValue === undefined || formValue === null;

  const classNames = cx(
    "form--select pr-2",
    inputClassName(),
    inputClassName(error ? "error" : "idle"),
    {
      "text-white": isEmpty,
      "formInput--hasContent": formValue,
      "disable-payment-options": rest.disabled,
    }
  );
  const wrapperClassNames = cx(className, "relative flex flex-col-reverse");

  const iconClassNames = cx(
    "transition duration-100 text-gray-500 formInput__icon",
    "absolute right-0 bottom-0 pl-3 pr-3 pb-4"
  );

  useEffect(() => {
    setValue(name, value);
  }, [name, setValue, value]);

  const optionPlaceholder = useMemo(
    () =>
      placeholder ? (
        <option value="" disabled>
          {placeholder}
        </option>
      ) : null,
    [placeholder]
  );

  return (
    <>
      <div>
        <div className={wrapperClassNames}>
          <div>
            <select
              name={name}
              className={classNames}
              value={value}
              ref={() => {
                register?.(name);
              }}
              aria-label={placeholder}
              aria-invalid={!!error}
              aria-describedby={errorID}
              onChange={handleOnChange}
              {...rest}
            >
              {optionPlaceholder}
              {children}
            </select>
            <img
              src="/chevron.svg"
              width={42}
              height={42}
              className={iconClassNames}
              alt="Select Icon"
            />
          </div>
          <label htmlFor={name} className={labelClassNames}>
            {placeholder} {keepPlaceHolderSize && <div>&nbsp;</div>}
          </label>
        </div>
      </div>
      {error && <ErrorText id={errorID}>{error}</ErrorText>}
    </>
  );
};

export default Select;
